module.exports = __webpack_public_path__ + "static/img/default.8bf28cda.png";